module.exports = __webpack_public_path__ + "img/face-4.5b7e19d0.jpg";